// extracted by mini-css-extract-plugin
module.exports = {"status-tag":"statusTag_status-tag__3QO_l"};